module.exports = __webpack_public_path__ + "img/gigastore-lp-api-mobile.b29d2740.png";